module.exports = __webpack_public_path__ + "static/baking-bad-bfc4dd7c26f3ae7e5d09226f651f6f88.webp";